// helper/iban.ts

export const IBAN_MIN_LENGTH = 15; // Norway currently shortest IBAN
export const IBAN_MAX_LENGTH = 34;

export function cleanIban(iban = ''): string {
  return iban.replace(/\s+/g, '').toUpperCase();
}

export function isIbanFormat(iban: string): boolean {
  const cleaned = cleanIban(iban);
  return cleaned.length >= IBAN_MIN_LENGTH && cleaned.length <= IBAN_MAX_LENGTH && /^[A-Z0-9]+$/.test(cleaned);
}

export function isGermanIbanFormat(iban: string): boolean {
  return /^DE\d{20}$/.test(iban); // DE + 20 digits = 22 chars total
}

/**
 * Offline validation for German IBANs using ISO 13616 / MOD-97.
 * Pure, client-safe, suitable for UI and tests.
 */
export function validateGermanIbanOffline(iban: string): boolean {
  const cleaned = cleanIban(iban);
  if (!isGermanIbanFormat(cleaned)) return false;

  const rearranged = cleaned.slice(4) + cleaned.slice(0, 4);
  const numeric = rearranged.replace(/[A-Z]/g, (ch) => (ch.charCodeAt(0) - 55).toString());

  let remainder = numeric;
  while (remainder.length > 2) {
    const block = remainder.slice(0, 9);
    remainder = (parseInt(block, 10) % 97).toString() + remainder.slice(block.length);
  }
  return parseInt(remainder, 10) % 97 === 1;
}
